<template>
  <div class="admin-page admin-page-panel team-management-page">
    <div class="admin-filter-bar">
      <a-input v-model="query.keyword" placeholder="俱乐部名称" style="width:220px; margin-right:10px;" />
      <a-select v-model="query.auditStatus" allow-clear placeholder="审核状态" style="width:160px; margin-right:10px;">
        <a-select-option :value="0">待审核</a-select-option>
        <a-select-option :value="1">已通过</a-select-option>
        <a-select-option :value="2">已拒绝</a-select-option>
      </a-select>
      <a-select v-model="query.teamSource" allow-clear placeholder="队伍来源" style="width:160px; margin-right:10px;">
        <a-select-option :value="0">正式俱乐部</a-select-option>
        <a-select-option :value="1">导入队伍</a-select-option>
      </a-select>
      <a-button type="primary" icon="search" @click="loadData">查询</a-button>
      <a-button v-if="isAdmin" type="primary" icon="plus" style="margin-left:12px;" @click="openEdit(null)">新增队伍</a-button>
    </div>

    <a-table class="team-list" :columns="columns" :data-source="data" rowKey="id" table-layout="fixed" :scroll="{ x: 1160 }" :loading="loading" :pagination="pagination" @change="handleTableChange">
      <template slot="teamIdentity" slot-scope="text, record">
        <div class="team-name">{{ record.teamName || '—' }}</div>
        <div class="team-secondary">队伍桨刻码</div>
        <team-code :value="record.teamCode" />
      </template>
      <template slot="teamContact" slot-scope="text, record">
        <div class="team-wrap">{{ record.leaderName || '未填写领队' }}</div>
        <div class="team-secondary team-wrap">{{ record.mobile || '未填写手机号' }}</div>
      </template>
      <template slot="teamStatus" slot-scope="text, record">
        <div class="team-status-line"><a-tag :color="record.teamSource === 1 ? 'blue' : 'green'">{{ record.teamSource === 1 ? '导入队伍' : '正式队伍' }}</a-tag></div>
        <div class="team-status-line"><span>审核</span><a-tag :color="auditMap[record.auditStatus] && auditMap[record.auditStatus].color">{{ auditMap[record.auditStatus] ? auditMap[record.auditStatus].label : '未知' }}</a-tag></div>
        <div class="team-status-line"><span>资料</span><a-tag :color="profileAuditMap[record.profileAuditStatus] && profileAuditMap[record.profileAuditStatus].color">{{ profileAuditMap[record.profileAuditStatus] ? profileAuditMap[record.profileAuditStatus].label : '未知' }}</a-tag></div>
      </template>
      <template slot="teamCounts" slot-scope="text, record">
        <div class="team-count">成员 <strong>{{ record.memberCount }}</strong></div>
        <div class="team-count">报名 <strong>{{ record.registrationCount }}</strong></div>
      </template>
      <template slot="teamRemark" slot-scope="text">
        <details v-if="text" class="team-remark"><summary><span>{{ text }}</span><small>展开备注</small></summary><div class="profile-text">{{ text }}</div></details>
        <span v-else class="team-secondary">—</span>
      </template>
      <span slot="auditStatus" slot-scope="text">
        <a-tag :color="auditMap[text] && auditMap[text].color">{{ auditMap[text] ? auditMap[text].label : '未知' }}</a-tag>
      </span>
      <span slot="teamSource" slot-scope="text">
        <a-tag :color="text === 1 ? 'blue' : 'green'">{{ text === 1 ? '导入队伍' : '正式队伍' }}</a-tag>
      </span>
      <span slot="profileAuditStatus" slot-scope="text">
        <a-tag :color="profileAuditMap[text] && profileAuditMap[text].color">{{ profileAuditMap[text] ? profileAuditMap[text].label : '未知' }}</a-tag>
      </span>
      <span class="admin-row-actions team-actions" slot="action" slot-scope="text, record">
        <a @click="openMembers(record)">队员</a>
        <a-divider type="vertical" />
        <a @click="openAudit(record)">{{ record.teamSource === 1 ? '查看' : '管理' }}</a>
        <a-divider type="vertical" />
        <a @click="openProfile(record)">资料管理</a>
        <template v-if="isAdmin">
          <a-divider type="vertical" />
          <a @click="openEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-popconfirm title="确定删除吗？" @confirm="handleDelete(record.id)">
            <a style="color:red;">删除</a>
          </a-popconfirm>
        </template>
      </span>
    </a-table>

    <a-modal
      v-model="visible"
      :title="auditForm.teamSource === 1 ? '查看队伍' : '管理俱乐部'"
      :width="1000"
      destroyOnClose
      :ok-button-props="{ props: { disabled: auditForm.teamSource === 1 } }"
      :okText="auditForm.teamSource === 1 ? '无需审核' : '提交审核'"
      @ok="submitAudit"
      @cancel="clearAuditDocuments"
    >
      <div v-if="auditRecord">
        <a-descriptions :column="2" bordered size="small" style="margin-bottom:20px;">
            <a-descriptions-item label="俱乐部名称">{{ auditRecord.teamName }}</a-descriptions-item>
            <a-descriptions-item label="队伍桨刻码"><team-code :value="auditRecord.teamCode" /></a-descriptions-item>
            <a-descriptions-item label="领队姓名">{{ auditRecord.leaderName || '未填写' }}</a-descriptions-item>
            <a-descriptions-item label="手机号">{{ auditRecord.mobile || '未填写' }}</a-descriptions-item>
            <a-descriptions-item label="所属区域">{{ [auditRecord.provinceName, auditRecord.cityName, auditRecord.districtName].filter(Boolean).join(' / ') || '未填写' }}</a-descriptions-item>
            <a-descriptions-item label="身份证正面">
              <a-spin :spinning="auditDocumentLoading.front">
                <a v-if="auditRecord.idCardFrontPreviewUrl" :href="auditRecord.idCardFrontPreviewUrl" target="_blank"><img :src="auditRecord.idCardFrontPreviewUrl" alt="身份证正面" class="id-card-image" /></a>
                <span v-else-if="auditRecord.hasIdCardFront">需要“查看证件原件”权限或文件不可用</span>
                <span v-else>未上传</span>
              </a-spin>
            </a-descriptions-item>
            <a-descriptions-item label="身份证反面">
              <a-spin :spinning="auditDocumentLoading.back">
                <a v-if="auditRecord.idCardBackPreviewUrl" :href="auditRecord.idCardBackPreviewUrl" target="_blank"><img :src="auditRecord.idCardBackPreviewUrl" alt="身份证反面" class="id-card-image" /></a>
                <span v-else-if="auditRecord.hasIdCardBack">需要“查看证件原件”权限或文件不可用</span>
                <span v-else>未上传</span>
              </a-spin>
            </a-descriptions-item>
            <a-descriptions-item label="队伍来源">
              <a-tag :color="auditRecord.teamSource === 1 ? 'blue' : 'green'">
                {{ auditRecord.teamSource === 1 ? '导入队伍' : '正式队伍' }}
              </a-tag>
            </a-descriptions-item>
            <a-descriptions-item label="主营水上运动">{{ auditRecord.mainWaterSport || '未填写' }}</a-descriptions-item>
            <a-descriptions-item label="审核状态">
              <a-tag :color="auditMap[auditRecord.auditStatus] && auditMap[auditRecord.auditStatus].color">
                {{ auditMap[auditRecord.auditStatus] ? auditMap[auditRecord.auditStatus].label : '未知' }}
              </a-tag>
            </a-descriptions-item>
            <a-descriptions-item label="成员数">{{ auditRecord.memberCount }}</a-descriptions-item>
            <a-descriptions-item label="报名次数">{{ auditRecord.registrationCount }}</a-descriptions-item>
            <a-descriptions-item label="原审核备注" :span="2">{{ auditRecord.auditRemark || '无' }}</a-descriptions-item>
        </a-descriptions>

        <a-form-model v-if="auditForm.teamSource !== 1" :model="auditForm" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
          <a-form-model-item label="审核结果">
            <a-radio-group v-model="auditForm.auditStatus">
              <a-radio :value="1">通过</a-radio>
              <a-radio :value="2">拒绝</a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item label="审核备注">
            <a-textarea v-model="auditForm.auditRemark" :rows="3" />
          </a-form-model-item>
        </a-form-model>
      </div>
    </a-modal>

    <a-modal
      v-model="profileVisible"
      title="俱乐部资料管理"
      :width="960"
      :confirmLoading="profileSaving"
      :ok-button-props="{ props: { disabled: !profileRecord || !profileRecord.hasDraft || profileRecord.profileAuditStatus !== 1 } }"
      okText="提交审核"
      destroyOnClose
      @ok="submitProfileAudit"
    >
      <a-spin :spinning="profileLoading">
        <div v-if="profileRecord">
          <a-alert
            v-if="!profileRecord.hasDraft"
            message="当前没有待审核的俱乐部资料"
            description="俱乐部尚未提交资料，或最近一次资料已经审核通过。"
            type="info"
            show-icon
            style="margin-bottom:20px;"
          />
          <a-alert
            v-else-if="profileRecord.profileAuditStatus === 3"
            message="该资料已被拒绝"
            description="请等待俱乐部修改并重新提交后再审核。"
            type="warning"
            show-icon
            style="margin-bottom:20px;"
          />
          <a-descriptions :column="2" bordered size="small" style="margin-bottom:20px;">
            <a-descriptions-item label="俱乐部名称">{{ profileRecord.teamName }}</a-descriptions-item>
            <a-descriptions-item label="资料状态">
              <a-tag :color="profileAuditMap[profileRecord.profileAuditStatus] && profileAuditMap[profileRecord.profileAuditStatus].color">
                {{ profileAuditMap[profileRecord.profileAuditStatus] ? profileAuditMap[profileRecord.profileAuditStatus].label : '未知' }}
              </a-tag>
            </a-descriptions-item>
            <a-descriptions-item label="俱乐部Logo" :span="2">
              <a v-if="profileRecord.clubLogoUrl" :href="profileRecord.clubLogoUrl" target="_blank">
                <img :src="profileRecord.clubLogoUrl" alt="俱乐部Logo" class="club-logo-image" />
              </a>
              <span v-else>未上传</span>
            </a-descriptions-item>
            <a-descriptions-item label="联系负责人">{{ profileRecord.contactPerson || '未填写' }}</a-descriptions-item>
            <a-descriptions-item label="训练地址">{{ profileRecord.trainingAddress || '未填写' }}</a-descriptions-item>
            <a-descriptions-item label="俱乐部简介" :span="2"><div class="profile-text">{{ profileRecord.clubIntroduction || '未填写' }}</div></a-descriptions-item>
            <a-descriptions-item label="历年参赛荣誉" :span="2"><div class="profile-text">{{ profileRecord.historicalHonors || '未填写' }}</div></a-descriptions-item>
            <a-descriptions-item label="最近提交时间" :span="2">{{ profileRecord.profileSubmittedAt || '未提交' }}</a-descriptions-item>
          </a-descriptions>

          <div class="daily-title">训练日常图文</div>
          <a-empty v-if="!profileRecord.trainingDaily || !profileRecord.trainingDaily.length" description="未上传训练日常" />
          <div v-else class="daily-grid">
            <div v-for="(item, index) in profileRecord.trainingDaily" :key="index" class="daily-card">
              <a :href="item.imageUrl" target="_blank"><img :src="item.imageUrl" alt="训练日常" /></a>
              <div>{{ item.text || '无文字说明' }}</div>
            </div>
          </div>

          <a-form-model v-if="profileRecord.hasDraft && profileRecord.profileAuditStatus === 1" :model="profileForm" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }" style="margin-top:24px;">
            <a-form-model-item label="审核结果">
              <a-radio-group v-model="profileForm.profileAuditStatus">
                <a-radio :value="2">通过并展示</a-radio>
                <a-radio :value="3">拒绝展示</a-radio>
              </a-radio-group>
            </a-form-model-item>
            <a-form-model-item label="审核备注">
              <a-textarea v-model="profileForm.profileAuditRemark" :rows="3" placeholder="拒绝时必须填写原因" />
            </a-form-model-item>
          </a-form-model>
        </div>
      </a-spin>
    </a-modal>

    <a-modal v-model="memberVisible" :title="`队员名单 · ${memberTeamName}`" width="860" :footer="null">
      <div style="margin-bottom:12px; display:flex; justify-content:flex-end;">
        <a-button type="primary" icon="plus" size="small" @click="openMemberAdd">新增成员</a-button>
      </div>
      <a-table :columns="memberColumns" :data-source="memberData" rowKey="id" :loading="memberLoading" :pagination="memberPagination" @change="handleMemberTableChange" size="middle">
        <span slot="isLeader" slot-scope="text">
          <a-tag :color="text === 1 ? 'blue' : 'default'">{{ text === 1 ? '领队' : '成员' }}</a-tag>
        </span>
        <span slot="joinStatus" slot-scope="text">
          <a-tag :color="text === 1 ? 'green' : text === 2 ? 'red' : 'orange'">{{ text === 1 ? '已加入' : text === 2 ? '已拒绝' : '待审核' }}</a-tag>
        </span>
        <span slot="memberAction" slot-scope="text, record">
          <template v-if="record.isLeader !== 1">
            <a @click="openMemberEdit(record)">编辑</a>
            <a-divider type="vertical" />
            <a-popconfirm title="确定删除该成员吗？" @confirm="handleMemberDelete(record)">
              <a style="color:red;">删除</a>
            </a-popconfirm>
          </template>
          <span v-else style="color:#CBDCE4;">领队</span>
        </span>
      </a-table>
    </a-modal>

    <a-modal v-model="memberAddVisible" title="新增成员" width="560" @ok="submitMemberAdd" :confirmLoading="memberSaving">
      <a-form-model :model="memberAddForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="姓名" required><a-input v-model="memberAddForm.memberName" /></a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="参赛位置"><a-input v-model="memberAddForm.racePosition" placeholder="如 鼓手/划手" /></a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="手机号" required><a-input v-model="memberAddForm.mobile" /></a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="身份证号"><a-input v-model="memberAddForm.idCardNo" placeholder="可留空" /></a-form-model-item>
          </a-col>
        </a-row>
        <div style="color:#7A8A9A; font-size:12px; text-align:center;">新增成员直接加入队伍（预录），可参与后续赛事报名选人</div>
      </a-form-model>
    </a-modal>

    <a-modal v-model="memberEditVisible" title="编辑成员" width="560" @ok="submitMemberEdit" :confirmLoading="memberSaving">      <a-form-model :model="memberEditForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="姓名"><a-input v-model="memberEditForm.memberName" /></a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="参赛位置"><a-input v-model="memberEditForm.racePosition" placeholder="如 鼓手/划手" /></a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="手机号"><a-input v-model="memberEditForm.mobile" /></a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="身份证号"><a-input v-model="memberEditForm.idCardNo" /></a-form-model-item>
          </a-col>
        </a-row>
        <template v-if="memberEditForm.joinStatus !== 1">
          <a-form-model-item label="审核结果">
            <a-radio-group v-model="memberEditForm.approved">
              <a-radio :value="1">通过</a-radio>
              <a-radio :value="2">拒绝</a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item label="审核备注">
            <a-input v-model="memberEditForm.remark" placeholder="拒绝时填写原因" />
          </a-form-model-item>
        </template>
      </a-form-model>
    </a-modal>

    <a-modal v-model="leaderPickVisible" title="选择已实名认证用户作为领队" width="520" :footer="null">
      <a-input v-model="leaderKeyword" placeholder="搜索姓名 / 手机号 / 桨刻号" allow-clear style="margin-bottom:12px;" @pressEnter="searchVerifiedUsers" />
      <div style="max-height:320px; overflow-y:auto;">
        <div v-for="u in verifiedUsers" :key="u.id" class="leader-pick-item" @click="pickLeader(u)">
          <div>
            <span style="font-weight:600;">{{ u.realName || '未填写姓名' }}</span>
            <a-tag v-if="u.verified" color="green" style="margin-left:6px;">已认证</a-tag>
            <a-tag v-else color="orange" style="margin-left:6px;">未认证</a-tag>
          </div>
          <div style="font-size:12px; color:#999;">{{ u.mobile || '—' }} · {{ u.jiangkNo || '—' }}</div>
        </div>
        <div v-if="!verifiedUsers.length" style="padding:20px 0; text-align:center; color:#999;">未搜索到用户（可先在认证中心完成实名认证）</div>
      </div>
    </a-modal>

    <a-modal v-model="editVisible" wrap-class-name="team-management-modal" :title="editForm.id ? '编辑队伍' : '新增队伍'" :width="760" @ok="submitEdit" :confirmLoading="saving">
      <a-form-model class="team-edit-form" layout="vertical" :model="editForm">
        <a-form-model-item label="队伍名称" required>
          <a-input v-model="editForm.teamName" />
        </a-form-model-item>
        <a-row :gutter="20">
          <a-col :span="24">
            <a-form-model-item label="领队姓名">
              <div class="team-leader-input">
                <a-input v-model="editForm.leaderName" placeholder="填写姓名，或选择已认证用户" />
                <a-button @click="openLeaderPick">选择用户</a-button>
              </div>
              <div v-if="editForm.leaderUserId" class="team-binding-note">
                已绑定用户：{{ editForm.leaderName }}（{{ editForm.leaderMobile || '' }}） <a @click="clearLeaderPick">清除绑定</a>
              </div>
            </a-form-model-item>
          </a-col>
          <a-col :xs="24" :sm="12">
            <a-form-model-item label="联系电话"><a-input v-model="editForm.mobile" /></a-form-model-item>
          </a-col>
          <a-col :xs="24" :sm="12">
            <a-form-model-item label="联系人"><a-input v-model="editForm.contactPerson" /></a-form-model-item>
          </a-col>
        </a-row>
        <a-form-model-item label="所属地区">
          <a-cascader v-model="editForm.region" :options="pcaOptions" placeholder="选择省/市/区" style="width:100%;"
            :show-search="{ filter }" change-on-select @change="onRegionChange" />
        </a-form-model-item>
        <a-form-model-item label="主攻水上项目"><a-input v-model="editForm.mainWaterSport" placeholder="如 龙舟500米" /></a-form-model-item>
        <a-form-model-item label="俱乐部介绍">
          <a-textarea v-model="editForm.clubIntroduction" :auto-size="{ minRows: 3, maxRows: 7 }" />
        </a-form-model-item>
        <a-form-model-item label="历史荣誉">
          <a-textarea v-model="editForm.historicalHonors" :auto-size="{ minRows: 3, maxRows: 7 }" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import {
  addDragonMember,
  auditDragonTeam,
  auditDragonTeamProfile,
  deleteDragonMember,
  deleteDragonTeam,
  getDragonMemberList,
  getDragonTeamProfile,
  getDragonTeamList,
  saveDragonTeam,
  updateDragonMember,
  searchVerifiedUsers,
  getAuthVerificationFile
} from '@/api'
import pcaData from '@/assets/pca-data'

import TeamCode from '@/components/TeamCode.vue'
export default {
  components: { TeamCode },
  data() {
    return {
      query: { keyword: '', auditStatus: undefined, teamSource: undefined },
      data: [],
      loading: false,
      visible: false,
      isAdmin: false,
      editVisible: false,
      editForm: {},
      saving: false,
      pcaOptions: pcaData,
      leaderPickVisible: false,
      leaderKeyword: '',
      verifiedUsers: [],
      memberVisible: false,
      memberTeamName: '',
      memberTeamId: null,
      memberData: [],
      memberLoading: false,
      memberPagination: { current: 1, pageSize: 10, total: 0 },
      memberColumns: [
        { title: '姓名', dataIndex: 'memberName' },
        { title: '手机号', dataIndex: 'mobile', width: 130 },
        { title: '身份证号', dataIndex: 'idCardNo', width: 170 },
        { title: '参赛位置', dataIndex: 'racePosition', width: 90 },
        { title: '身份', dataIndex: 'isLeader', width: 80, scopedSlots: { customRender: 'isLeader' } },
        { title: '状态', dataIndex: 'joinStatus', width: 90, scopedSlots: { customRender: 'joinStatus' } },
        { title: '操作', key: 'memberAction', width: 120, scopedSlots: { customRender: 'memberAction' } }
      ],
      memberEditVisible: false,
      memberEditForm: {},
      memberSaving: false,
      memberAddVisible: false,
      memberAddForm: {},
      profileVisible: false,
      profileLoading: false,
      profileSaving: false,
      auditRecord: null,
      auditDocumentLoading: { front: false, back: false },
      profileRecord: null,
      auditForm: {
        auditStatus: 1
      },
      pagination: { current: 1, pageSize: 10, total: 0 },
      auditMap: {
        0: { label: '待审核', color: 'orange' },
        1: { label: '已通过', color: 'green' },
        2: { label: '已拒绝', color: 'red' }
      },
      profileAuditMap: {
        0: { label: '未提交', color: 'default' },
        1: { label: '审核中', color: 'orange' },
        2: { label: '已通过', color: 'green' },
        3: { label: '已拒绝', color: 'red' }
      },
      profileForm: {
        profileAuditStatus: 2,
        profileAuditRemark: ''
      },
      columns: [
        { title: '俱乐部 / 队伍', dataIndex: 'teamName', width: 300, scopedSlots: { customRender: 'teamIdentity' } },
        { title: '领队 / 联系方式', key: 'contact', width: 180, scopedSlots: { customRender: 'teamContact' } },
        { title: '来源与状态', key: 'status', width: 180, scopedSlots: { customRender: 'teamStatus' } },
        { title: '成员 / 报名', key: 'counts', width: 100, scopedSlots: { customRender: 'teamCounts' } },
        { title: '审核备注', dataIndex: 'auditRemark', width: 200, scopedSlots: { customRender: 'teamRemark' } },
        { title: '操作', key: 'action', width: 200, scopedSlots: { customRender: 'action' } }
      ]
    }
  },
  created() {
    this.loadData()
  },
  beforeDestroy() {
    this.clearAuditDocuments()
  },
  methods: {
    loadData() {
      this.loading = true
      getDragonTeamList({
        page: this.pagination.current,
        pageSize: this.pagination.pageSize,
        keyword: this.query.keyword,
        auditStatus: this.query.auditStatus,
        teamSource: this.query.teamSource
      }).then(res => {
        this.data = res.data.list
        this.pagination.total = res.data.total
        this.isAdmin = res.data.scope === 'all'
      }).finally(() => {
        this.loading = false
      })
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current
      this.loadData()
    },
    openMembers(record) {
      this.memberTeamName = record.teamName || ''
      this.memberTeamId = record.id
      this.memberVisible = true
      this.memberPagination = { current: 1, pageSize: 10, total: 0 }
      this.loadMembers(record.id)
    },
    loadMembers(teamId) {
      this.memberLoading = true
      getDragonMemberList({
        page: this.memberPagination.current,
        pageSize: this.memberPagination.pageSize,
        teamId
      }).then(res => {
        this.memberData = res.data.list
        this.memberPagination.total = res.data.total
      }).finally(() => {
        this.memberLoading = false
      })
    },
    handleMemberTableChange(pagination) {
      this.memberPagination.current = pagination.current
      this.loadMembers(this.memberTeamId)
    },
    openMemberEdit(record) {
      this.memberEditForm = {
        memberId: record.id,
        memberName: record.memberName || '',
        mobile: record.mobile || '',
        idCardNo: record.idCardNo || '',
        racePosition: record.racePosition || '',
        joinStatus: record.joinStatus,
        approved: undefined,
        remark: ''
      }
      this.memberEditVisible = true
    },
    submitMemberEdit() {
      if (!this.memberEditForm.memberName) {
        this.$message.warning('请填写姓名')
        return
      }
      this.memberSaving = true
      updateDragonMember(this.memberEditForm).then(() => {
        this.$message.success('成员资料已更新')
        this.memberEditVisible = false
        this.loadMembers(this.memberTeamId)
        this.loadData()
      }).finally(() => {
        this.memberSaving = false
      })
    },
    openMemberAdd() {
      this.memberAddForm = {
        teamId: this.memberTeamId,
        memberName: '',
        mobile: '',
        idCardNo: '',
        racePosition: ''
      }
      this.memberAddVisible = true
    },
    submitMemberAdd() {
      if (!this.memberAddForm.memberName) {
        this.$message.warning('请填写姓名')
        return
      }
      if (!this.memberAddForm.mobile) {
        this.$message.warning('请填写手机号')
        return
      }
      this.memberSaving = true
      addDragonMember(this.memberAddForm).then(() => {
        this.$message.success('成员已加入队伍')
        this.memberAddVisible = false
        this.loadMembers(this.memberTeamId)
        this.loadData()
      }).finally(() => {
        this.memberSaving = false
      })
    },
    handleMemberDelete(record) {
      deleteDragonMember({ memberId: record.id }).then(() => {
        this.$message.success('成员已删除')
        this.loadMembers(this.memberTeamId)
        this.loadData()
      }).catch(err => {
        this.$message.error(err.message || '删除失败')
      })
    },
    openEdit(record) {
      if (record) {
        this.editForm = {
          id: record.id,
          teamName: record.teamName || '',
          leaderName: record.leaderName || '',
          mobile: record.mobile || '',
          provinceName: record.provinceName || '',
          cityName: record.cityName || '',
          districtName: record.districtName || '',
          region: [record.provinceName, record.cityName, record.districtName].filter(Boolean),
          leaderUserId: record.leaderUserId || null,
          leaderMobile: record.mobile || '',
          contactPerson: record.contactPerson || '',
          mainWaterSport: record.mainWaterSport || '',
          clubIntroduction: record.clubIntroduction || '',
          historicalHonors: record.historicalHonors || ''
        }
      } else {
        this.editForm = {
          teamName: '',
          leaderName: '',
          mobile: '',
          provinceName: '',
          cityName: '',
          districtName: '',
          region: [],
          leaderUserId: null,
          leaderMobile: '',
          contactPerson: '',
          mainWaterSport: '',
          clubIntroduction: '',
          historicalHonors: ''
        }
      }
      this.editVisible = true
    },
    openLeaderPick() {
      this.leaderKeyword = ''
      this.verifiedUsers = []
      this.searchVerifiedUsers()
      this.leaderPickVisible = true
    },
    searchVerifiedUsers() {
      searchVerifiedUsers({ keyword: this.leaderKeyword || '', limit: 30 }).then(res => {
        this.verifiedUsers = res.data || []
      }).catch(() => {})
    },
    pickLeader(user) {
      if (!user.verified) {
        this.$message.warning('该用户未完成实名认证，不能作为领队')
        return
      }
      this.editForm.leaderName = user.realName || ''
      this.editForm.mobile = user.mobile || ''
      this.editForm.leaderUserId = user.id
      this.editForm.leaderMobile = user.mobile || ''
      this.leaderPickVisible = false
      this.$message.success('已绑定领队：' + (user.realName || ''))
    },
    clearLeaderPick() {
      this.editForm.leaderUserId = null
      this.editForm.leaderMobile = ''
      this.editForm.leaderName = ''
      this.editForm.mobile = ''
      this.$message.info('已解除领队绑定，可手动填写')
    },
    onRegionChange(value) {
      this.editForm.provinceName = (value && value[0]) || ''
      this.editForm.cityName = (value && value[1]) || ''
      this.editForm.districtName = (value && value[2]) || ''
    },
    filter(inputValue, path) {
      return path.some(option => String(option.label).indexOf(inputValue) >= 0)
    },
    submitEdit() {
      if (!this.editForm.teamName) {
        this.$message.warning('请填写队伍名称')
        return
      }
      this.saving = true
      saveDragonTeam(this.editForm).then(() => {
        this.$message.success(this.editForm.id ? '队伍资料已更新' : '队伍已创建')
        this.editVisible = false
        this.loadData()
      }).finally(() => {
        this.saving = false
      })
    },
    openAudit(record) {
      this.clearAuditDocuments()
      this.auditRecord = {
        ...record,
        idCardFrontPreviewUrl: '',
        idCardBackPreviewUrl: ''
      }
      this.auditForm = {
        teamId: record.id,
        teamName: record.teamName,
        teamSource: record.teamSource,
        auditStatus: record.auditStatus === 2 ? 2 : 1,
        auditRemark: record.auditRemark
      }
      this.visible = true
      this.loadAuditDocument('front', record.idCardFrontAttachmentId)
      this.loadAuditDocument('back', record.idCardBackAttachmentId)
    },
    loadAuditDocument(side, attachmentId) {
      if (!attachmentId || !this.auditRecord) return
      const previewKey = side === 'front' ? 'idCardFrontPreviewUrl' : 'idCardBackPreviewUrl'
      this.$set(this.auditDocumentLoading, side, true)
      getAuthVerificationFile(attachmentId).then(response => {
        if (!this.auditRecord) return
        const previewUrl = URL.createObjectURL(response.data)
        this.$set(this.auditRecord, previewKey, previewUrl)
      }).catch(() => {}).finally(() => {
        this.$set(this.auditDocumentLoading, side, false)
      })
    },
    clearAuditDocuments() {
      if (this.auditRecord) {
        const previewKeys = ['idCardFrontPreviewUrl', 'idCardBackPreviewUrl']
        previewKeys.forEach(key => {
          if (this.auditRecord[key]) URL.revokeObjectURL(this.auditRecord[key])
        })
      }
      this.auditDocumentLoading = { front: false, back: false }
    },
    submitAudit() {
      if (this.auditForm.teamSource === 1) return
      auditDragonTeam(this.auditForm).then(() => {
        this.$message.success('审核完成')
        this.clearAuditDocuments()
        this.visible = false
        this.loadData()
      })
    },
    openProfile(record) {
      this.profileVisible = true
      this.profileLoading = true
      this.profileRecord = null
      getDragonTeamProfile({ teamId: record.id }).then(res => {
        this.profileRecord = res.data || null
        this.profileForm = {
          teamId: record.id,
          profileAuditStatus: 2,
          profileAuditRemark: (res.data && res.data.profileAuditRemark) || ''
        }
      }).finally(() => {
        this.profileLoading = false
      })
    },
    submitProfileAudit() {
      if (!this.profileRecord || !this.profileRecord.hasDraft || this.profileRecord.profileAuditStatus !== 1) return
      if (this.profileForm.profileAuditStatus === 3 && !String(this.profileForm.profileAuditRemark || '').trim()) {
        this.$message.warning('拒绝时请填写拒绝原因')
        return
      }
      this.profileSaving = true
      auditDragonTeamProfile(this.profileForm).then(() => {
        this.$message.success('俱乐部资料审核完成')
        this.profileVisible = false
        this.loadData()
      }).finally(() => {
        this.profileSaving = false
      })
    },
    handleDelete(id) {
      deleteDragonTeam({ teamId: id }).then(() => {
        this.$message.success('删除成功')
        this.loadData()
      }).catch(err => {
        this.$message.error((err && err.msg) || '删除失败，请检查登录状态后重试')
      })
    }
  }
}
</script>

<style scoped>
.team-management-page { min-width: 0; }
.team-list >>> .ant-table-thead > tr > th { white-space: nowrap; }
.team-list >>> .ant-table-tbody > tr > td { vertical-align: top; }
.team-name, .team-wrap, .team-binding-note { overflow-wrap: anywhere; word-break: normal; }
.team-name { font-weight: 600; line-height: 1.6; margin-bottom: 8px; }
.team-secondary { color: var(--jk-text-secondary, #72818c); font-size: 12px; line-height: 1.6; }
.team-status-line { display: flex; align-items: center; gap: 8px; margin-bottom: 6px; font-size: 12px; }
.team-status-line:last-child { margin-bottom: 0; }
.team-count { white-space: nowrap; line-height: 1.9; }
.team-count strong { margin-left: 6px; font-variant-numeric: tabular-nums; }
.team-actions { gap: 8px 14px; }
.team-actions >>> .ant-divider-vertical { display: none; }
.team-remark { overflow-wrap: anywhere; }
.team-remark summary { cursor: pointer; }
.team-remark summary > span { display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }
.team-remark summary > small { color: var(--jk-primary, #167a7b); }
.team-remark[open] summary > span { display: none; }
.team-edit-form >>> .ant-form-item { margin-bottom: 20px; }
.team-edit-form >>> .ant-form-item-label { line-height: 1.5; padding: 0 0 6px; text-align: left; }
.team-edit-form >>> .ant-form-item-control { line-height: 1.6; }
.team-leader-input { display: flex; gap: 10px; align-items: flex-start; }
.team-leader-input > .ant-input { flex: 1; min-width: 0; }
.team-leader-input > .ant-btn { flex: 0 0 auto; }
.team-binding-note { margin-top: 8px; font-size: 12px; color: var(--jk-text-secondary, #72818c); }
.id-card-image {
  width: 220px;
  max-height: 135px;
  object-fit: cover;
}

.club-logo-image {
  width: 140px;
  height: 140px;
  border-radius: 12px;
  object-fit: cover;
}

.profile-text {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  line-height: 1.7;
}

.daily-title {
  margin-bottom: 12px;
  font-weight: 600;
}

.daily-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
}

.daily-card {
  overflow: hidden;
  border: 1px solid #edf0f2;
  border-radius: 10px;
}

.daily-card img {
  width: 100%;
  height: 150px;
  object-fit: cover;
}

.daily-card div {
  padding: 10px 12px;
  color: #59636c;
  line-height: 1.6;
}

.leader-pick-item {
  padding: 10px 12px;
  border: 1px solid #EEF2F6;
  border-radius: 8px;
  margin-bottom: 8px;
  cursor: pointer;
  transition: all 0.15s;
}
.leader-pick-item:hover {
  border-color: #4ECDC4;
  background: #F4FAFA;
}
</style>
